import { type TrackedEventId, normalizeTrackedEventPayload } from '@/common/catalogs/analytics/events';
import type { JsonRecord } from '@/common/types/json';

export type AnalyticsEvent = TrackedEventId;

type DebugWindow = Window & {
    dev?: boolean;
};

/**
 * Website analytics stay in the page. Since the member-only analytics decision the website
 * records nothing server-side and posts nothing to a first-party endpoint: Mixpanel and Brevo
 * listen to this `ud:analytics` bus, and pre-signup behaviour lives in Mixpanel.
 */
export function track(event: AnalyticsEvent, props?: JsonRecord) {
    if (typeof window === 'undefined') return;

    const normalized = normalizeTrackedEventPayload({
        event,
        data: props,
    });
    if (!normalized) return;

    window.dispatchEvent(
        new CustomEvent('ud:analytics', {
            detail: {
                event: normalized.event,
                source: 'landing',
                ...(normalized.data ?? {}),
            },
        }),
    );

    const isDev = Boolean((window as DebugWindow).dev);
    if (isDev) console.debug('[analytics]', normalized.event, normalized.data ?? {});
}
